/* eslint-disable @typescript-eslint/no-explicit-any */
import { NavigateProps as BaseNavProps, Navigate as ReactDomNavigate } from 'react-router-dom';

import { routes } from './config';

import { RouteProps } from './Link';

type NavigateBaseProps = Omit<BaseNavProps, 'to'>;

export type NavigateProps = NavigateBaseProps & RouteProps;

/**
 * A typed instance of the default <Navigate /> component
 */
export function Navigate({ to, ...props }: NavigateProps) {
  const routeConfig = routes[to] as any;

  if (!routeConfig) return <ReactDomNavigate to={to} {...props} />;

  const href = routeConfig.getPath?.((props as any)?.params) ?? routeConfig.path;

  return <ReactDomNavigate to={href} {...props} />;
}
